import { Config, install } from '@sitebase/tracking-kit';
import { publish } from '@wh/message-bus';

const trackingInfo = {
  invoke: {
    install: ([options]: [Config]) => {
      install(options);
    },
    track: ([data]: [object]) => {
      publish({
        topic: 'wh.analytics.command.interaction.track',
        data,
      });
    },
    updateStore: ([data]: [{ [key: string]: any }]) => {
      const entries = Object.entries(data).map(([key, value]) => ({
        key,
        value,
      }));
      if (window.WH?.storages) {
        window.WH.storages.business.setEntries(entries);
      }
    },
  },
};

export default trackingInfo;
